import { render, staticRenderFns } from "./invCenterwise.vue?vue&type=template&id=7b18174b&"
import script from "./invCenterwise.vue?vue&type=script&lang=js&"
export * from "./invCenterwise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports